import * as common from '../common.js'
import * as calendarCommon from '../calendar-common.js'
import $ from 'jquery'
import Vue from 'vue'
import moment from 'moment'
import { ajaxWrapper } from '../ajaxwrapper.js'
import {
    couponBanner,
    couponBannerModal,
    couponBadge,
    couponBadgeModal,
    couponBadgeBanner
} from './coupon.js'

let holidaysData = {};

document.addEventListener("DOMContentLoaded", function () {
    window.moment = moment;

    const params = new URLSearchParams(window.location.search);

    // window.data_veを参照
    let data_ve_merge = {
        dayOfWeekList: createDayOfWeekList(),
        rmInfo: [],               //部屋人数情報
        isLnumPerRoom: true,    //部屋ごとの人数を選択する
        ltInfoJoinSave: null,   //人数情報（全部屋合計）
        dontSubmitParam: false, //サブミット対象外の項目を一時的にdisabledにするために使うフラグ
        screenTransitionIsEnabledValue: true,   //次画面遷移を一時的に無効にするフラグ（検索条件を変えて再検索していない時など）
        DPCheckEnable: params.get('DPCheckEnable') == 'true',
    };
    window.data_ve = Object.assign(window.data_ve, data_ve_merge);

    if (!data_ve.notOnSale) {
        // カレンダー表示月を基準にする
        const baseDate = data_ve['calendarSalesYearList'] && data_ve['calendarSalesYearList'].length > 0
            ? moment(data_ve['calendarDispYearMonth'],'YYYYMMDD').toDate()
            : moment().toDate();

        // 表示用のカレンダーデータを生成して、Controllerのデータと統合する
        const calendar = createCalendar(baseDate);
        data_ve['calendarDispYear'] = moment(data_ve['calendarDispYearMonth'],'YYYYMMDD').format('YYYYMM');
        const merged = mergeCalendar(calendar, data_ve['calendarDispYear'], data_ve.calendarSalesYearList);
        data_ve['weeks'] = merged;

        //部屋情報作る
        makeRoomInfo(data_ve)
    }

    if (data_ve.paymentMethods == null) {
        data_ve.paymentMethods = [];
    }

    window.ve = readyForVue(data_ve);
});

function mergeCalendar(calendar, calendarDispYear, calendarSalesYearList) {
    let calendarList = null;
    if (null !== calendarSalesYearList) {
        for (let cl of calendarSalesYearList) {
            if (cl.calendarSalesYear === calendarDispYear) {
                calendarList = cl.calendarList;
            }
        }
    }

    const holidays = Object.keys(holidaysData); // YYYY-MM-DD

    return calendar.map(week =>
        week.map(day => {
            const key = moment(day).format('YYYYMMDD');
            const holidayKey = moment(day).format('YYYY-MM-DD');
            const dayString = moment(day).format('D');
            const setting = {
                holiday: holidays.includes(holidayKey),
            };

            if (!day && !setting) {
                return null;
            }

            let ppc = null;
            if (null !== calendarSalesYearList && calendarList) {
                for (let tmprpc of calendarList) {
                    if (null !== tmprpc && tmprpc.planSalesDate === moment(day).format('DD')) {
                        ppc = tmprpc;
                    }
                }
            }

            return {
                date: day,
                dateString: key,
                dayString: dayString,
                holiday: setting['holiday'],
                calendarItem: ppc,
            };
        })
    );
}

function createDayOfWeekList() {
    return [
        {
            text: $t("common.calendar.sunday.short"),
            saturday: false,
            sunday: true,
        },
        {
            text: $t("common.calendar.monday.short"),
            saturday: false,
            sunday: false,
        },
        {
            text: $t("common.calendar.tuesday.short"),
            saturday: false,
            sunday: false,
        },
        {
            text: $t("common.calendar.wednesday.short"),
            saturday: false,
            sunday: false,
        },
        {
            text: $t("common.calendar.thursday.short"),
            saturday: false,
            sunday: false,
        },
        {
            text: $t("common.calendar.friday.short"),
            saturday: false,
            sunday: false,
        },
        {
            text: $t("common.calendar.saturday.short"),
            saturday: true,
            sunday: false,
        },
    ]
}

function range(begin, end) {
    const size = end ? end - begin : begin;
    const origin = end ? begin : 0;
    return [...Array(size).keys()].map(i => i + origin);
}

/**
 * 引数の日時のカレンダーデータを生成する
 * 前月と翌月はnull, 当月の場合はDateをもつ週ごとのリストを返す。
 *
 * [
 *     [ ..., 31, null, null]
 *     [ null, null, 1, 2, 3, 4, 5],
 *     [ 6,    7,          ...,  12],
 *     ...
 * ]
 *
 * @param baseDate カレンダーの基準日
 * @returns 週ごとのDateのリスト
 */
function createCalendar(baseDate) {
    const year = baseDate.getFullYear();
    const month = baseDate.getMonth();
    const first = moment(new Date(year, month, 1)); // 当月の初日

    // 初週の前月をnullで埋める
    let week = new Array(first.toDate().getDay()).fill(null);

    // 月内の週の分だけリストを作る
    const weeks = range(first.daysInMonth())
        .map(i => new Date(year, month, i + 1))
        .reduce((weeks, today) => {
            week.push(today);
            if (week.length === 7) {
                weeks.push(week);
                week = [];
            }

            return weeks;
        }, []);

    // 最終週の翌月をnullで埋める
    const finalWeek = week.concat(new Array(7 - week.length).fill(null));
    if (finalWeek[0]) {
        weeks.push(finalWeek);
    }
    return weeks;
}

function makeRoomInfo(data_ve) {
    //部屋・宿泊人数パラメータをdata_ve.rmInfo以下に纏める
    //部屋-宿泊者タイプ・宿泊人数の形式で構造を作る
    let rmMaxIndex = 0;     //部屋の最大指定数
    let ltMaxIndex = 0;     //宿泊者タイプ人数の最大指定数
    let roomDtoSize = 0;    // 予約室のDto数
    data_ve.rmInfo = Array.from([]);//部屋タイプコード
    let rmList = range(1, 10 + 1);
    for (let i = 1; i <= 10; i++) {
        let rmcdKey = "rmcd" + ("000" + i).slice(-3);
        let rmcd = "";
        let rmKey = "rm" + ("000" + i).slice(-3);
        let rm = "";
        if (data_ve.hasOwnProperty(rmcdKey) && data_ve[rmcdKey]) {
            rmcd = data_ve[rmcdKey];
        } else {
            rmcd = "";
        }
        if (data_ve.hasOwnProperty(rmKey) && data_ve[rmKey]) {
            rm = data_ve[rmKey];
            rmList = rmList.filter(rmno => rmno !== rm);
            roomDtoSize++;
        } else {
            rm = rmList.shift();
        }
        if (rm > rmMaxIndex) {
            rmMaxIndex = rm;
        }
        let rmInfoOne = {
            rmcd: rmcd,
            ltInfo: Array.from([]),
        };
        data_ve.rmInfo[rm - 1] = rmInfoOne;
        if (data_ve.searchRoomList[rm - 1]) {
            for (let msld of data_ve.searchRoomList[rm - 1].modalSearchLodgerDtoList) {
                rmInfoOne.ltInfo.push({
                    lt: msld.searchLodgerTypeCode,
                    ltname: msld.searchLodgerTypeName,
                    lnum: msld.searchLodgerTypeNum,
                    lodgingPossibleNumMin: msld.lodgingPossibleNumMin,
                    lodgingPossibleNumMax: msld.lodgingPossibleNumMax,
                });
            }
        }
    }
    //宿泊人数を設定する
    rmList = range(1, 10 + 1);
    for (let i = 1; i <= 10; i++) {
        let rmKey = "rm" + ("000" + i).slice(-3);
        let rm = "";
        if (data_ve.hasOwnProperty(rmKey) && data_ve[rmKey]) {
            rm = data_ve[rmKey];
            rmList = rmList.filter(rmno => rmno !== rm);
        } else {
            rm = rmList.shift();
        }
        for (let l = 1; l <= 11; l++) {
            let lt = "";
            if (data_ve.searchRoomList[rm - 1]) {
                if (rm > ltMaxIndex) {
                    ltMaxIndex = rm;
                }
                if (data_ve.searchRoomList[rm - 1] &&
                    data_ve.searchRoomList[rm - 1].modalSearchLodgerDtoList &&
                    data_ve.searchRoomList[rm - 1].modalSearchLodgerDtoList[l - 1]) {
                    let msldl = data_ve.searchRoomList[rm - 1].modalSearchLodgerDtoList[l - 1];
                    lt = msldl.searchLodgerTypeCode;
                    data_ve.rmInfo[rm - 1].ltInfo.map(lti => {
                        if (lti.lt === lt &&
                            msldl.hasOwnProperty("searchLodgerTypeNum") &&
                            msldl.searchLodgerTypeNum) {
                            lti.lnum = msldl.searchLodgerTypeNum;
                            if (msldl.lodgingPossibleNumMin && lti.lnum < msldl.lodgingPossibleNumMin) {
                                lti.lnum = msldl.lodgingPossibleNumMin;
                            }
                            lti.lodgingPossibleNumMin = msldl.lodgingPossibleNumMin;
                            lti.lodgingPossibleNumMax = msldl.lodgingPossibleNumMax;
                        }
                        return lti;
                    });
                }
            }
        }
    }
    //部屋ごとの人数を選択するフラグ判定
    if (data_ve.sumrm > 1 && data_ve.sumrm === roomDtoSize) {
        data_ve.isLnumPerRoom = true;
        if (data_ve.dpck==false){
            data_ve.isLnumPerRoom = false;
        }
    }
}

function readyForVue(data_ve) {

    // 余計な予約室のデータを外す
    data_ve.rmInfo.splice(data_ve.sumrm);

    //初期データ保存
    let data_initial = {};
    Object.assign(data_initial, {}, data_ve);
    data_initial.rmInfo = JSON.parse(JSON.stringify(data_ve.rmInfo));

    //プラン選択時の前回ajax取り消し用
    let acivatePlanPlanDeffered = null;
    let acivatePlanCalendarDeffered = null;

    return new Vue({
        el: '#mainContents',
        data: function () {
            return Object.assign({}, data_ve);
        },
        i18n: window.i18n,
        computed: {
            screenTransitionIsEnabled: {
                get: function () {
                    return this.screenTransitionIsEnabledValue;
                },
                set: function (newValue) {
                    return this.screenTransitionIsEnabledValue = (newValue) ? true : false;
                },
            },
            isPlanPaymentGenchi: {
                get: function () {
                    return this.isPlanPayment("0");
                },
            },
            isPlanPaymentCredit: {
                get: function () {
                    return this.isPlanPayment("1");
                },
            },
            isPlanPaymentPaypay: {
                get: function () {
                    return this.isPlanPayment("2");
                },
            },
            hasPaymentMethod: {
                get: function () {
                    return Object.keys(this.paymentMethods).length > 0;
                },
            },

            isDisplayMessageExists: {
                get: function () {
                    if (this.displayMessage === null ||
                        this.displayMessage.length === 0) {
                        return false;
                    }
                    return true;
                },
            },
            calendarYearPrev: function () {
                return moment(this.calendarDispYear + "01").subtract(moment.duration(1, 'months')).format('YYYYMM');
            },
            calendarYearNext: function () {
                return moment(this.calendarDispYear + "01").add(moment.duration(1, 'months')).format('YYYYMM');
            },
            calendarLabelNow: function () {
                return moment(this.calendarDispYear + "01").format('YYYY/MM');
            },
            calendarLabelPrev: function () {
                return moment(this.calendarYearPrev + "01").format('YYYY/MM');
            },
            calendarLabelNext: function () {
                return moment(this.calendarYearNext + "01").format('YYYY/MM');
            },
            sumrmComputed: {
                get: function () {
                    return this.sumrmTemp == null ? this.sumrm : this.sumrmTemp;
                },
                set: function (value) {
                    if (value === 1) {
                        this.isLnumPerRoom = false;
                    }
                    let oldSumRm = this.isLnumPerRoom ? this.sumrmTemp : 1;
                    let newSumRm = this.isLnumPerRoom ? value : 1;
                    this.sumrmTemp = value;
                    if (oldSumRm > 0 && oldSumRm < newSumRm) {
                        for (let i = oldSumRm; i < newSumRm; i++) {
                            this.rmInfoCopy(oldSumRm - 1, i);
                        }
                        this.rmInfo = JSON.parse(JSON.stringify(this.rmInfo));
                    }
                }
            },
            isLnumPerRoomComputed: {
                get: function () {
                    return this.isLnumPerRoom;
                },
                set: function (value) {
                    this.isLnumPerRoom = value;
                    if (value === true) {
                        let oldSumRm = 1;
                        let newSumRm = this.sumrmTemp;
                        for (let i = oldSumRm; i < newSumRm; i++) {
                            this.rmInfoCopy(oldSumRm - 1, i);
                        }
                        this.rmInfo = JSON.parse(JSON.stringify(this.rmInfo));
                    }
                }
            },
            ltInfoJoin: function () {
                if (this.ltInfoJoinSave === null) {
                    this.ltInfoJoinSave = this._ltInfoJoinComputed;
                }
                return this.ltInfoJoinSave;
            },
            _ltInfoJoinComputed: function () {
                let ltInfo = Array.from([]);
                if (this.sumrmTemp == null) this.sumrmTemp = this.sumrm;
                if (this.isLnumPerRoom) {
                    for (let roomIndex in this.rmInfo) {
                        for (let ltIndex in this.rmInfo[roomIndex].ltInfo) {
                            if (!ltInfo[ltIndex]) {
                                ltInfo[ltIndex] = Object.assign({}, this.rmInfo[roomIndex].ltInfo[ltIndex]);
                                ltInfo[ltIndex].lnum = 0;
                            }
                            if (this.rmInfo[roomIndex].ltInfo[ltIndex].lnum) {
                                ltInfo[ltIndex].lnum += parseInt(this.rmInfo[roomIndex].ltInfo[ltIndex].lnum);
                            }
                        }
                    }
                } else {
                    for (let ltIndex in this.rmInfo[0].ltInfo) {
                        if (!ltInfo[ltIndex]) {
                            ltInfo[ltIndex] = Object.assign({}, this.rmInfo[0].ltInfo[ltIndex]);
                            ltInfo[ltIndex].lnum = parseInt(this.rmInfo[0].ltInfo[ltIndex].lnum) * this.sumrmTemp;
                        }
                    }
                }
                this.sumrm = this.sumrmTemp;
                return ltInfo;
            },
            totalPeople: function () {
                let total = 0;
                const ltInfo = this._ltInfoJoinComputed;
                for (let i = 0; i < ltInfo.length; i++) {
                    if (ltInfo[i].lnum) {
                        total += parseInt(ltInfo[i].lnum);
                    }
                }
                return total;
            },
            _ltImplode: function () {
                let ltImplodedAllRoom = Array.from([]);
                for (let roomIndex in this.rmInfo) {
                    let ltImploded = Array.from([]);
                    let wk = Array.from([]);
                    for (let ltIndex in this.rmInfo[roomIndex].ltInfo) {
                        let value = this.rmInfo[roomIndex].ltInfo[ltIndex].lt;
                        wk.push(value);
                        Array.prototype.push.apply(ltImploded, wk);
                        wk = Array.from([]);
                    }
                    ltImplodedAllRoom[roomIndex] = ltImploded.join("_");
                }
                return ltImplodedAllRoom;
            },
            _lnumImplode: function () {
                let lnumImplodedAllRoom = Array.from([]);
                for (let roomIndex in this.rmInfo) {
                    let lnumImploded = Array.from([]);
                    let wk = Array.from([]);
                    for (let lnumindex in this.rmInfo[roomIndex].ltInfo) {
                        let value = this.rmInfo[roomIndex].ltInfo[lnumindex].lnum;
                        wk.push(value);
                        Array.prototype.push.apply(lnumImploded, wk);
                        wk = Array.from([]);
                    }
                    lnumImplodedAllRoom[roomIndex] = lnumImploded.join("_");
                }
                return lnumImplodedAllRoom;
            },
            stayDays: function () {
                return range(this.nightsMin, this.nightsMax + 1);
            },
            couponsOfPlan() {
                const planCode = this.pl;
                if (planCode == null || this.coupons == null) {
                    return [];
                }
                return this.coupons.filter(coupon => {
                    const targetPlanCodes = (coupon.targetPlans || []).map(plan => plan.code);
                    return (targetPlanCodes.length == 0 || targetPlanCodes.includes(planCode));
                });
            },
        },
        methods: {
            $t: window.$t,
            isPlanPayment: function (value) {
                if (!this.planPaymentMethodKbn) {
                    return false;
                }
                var splitPlanPayment = this.planPaymentMethodKbn.split(',');
                if (splitPlanPayment.indexOf(value) >= 0) {
                    return true;
                } else {
                    return false;
                }
            },
            isLogerAvailable: function (lodgerTypeCode) {
                for (let lodger of this.logerAvailabilityArea) {
                    if (lodger.logerTypeCode === lodgerTypeCode) {
                        if (lodger.logerAvailabilityKbn === 'N') {
                            return true;
                        } else {
                            return false;
                        }
                    }
                }
                return false;
            },
            isDisplayLodgerMessage: function (value) {
                for (let lodger of this.logerAvailabilityArea) {
                    if (lodger.logerAvailabilityKbn === 'N') {
                        return true;
                    }
                }
                return false;
            },
            getLnumRange: function (lodger) {
                let lnmin = lodger.lodgingPossibleNumMin;
                let lnmax = lodger.lodgingPossibleNumMax;
                return range(lnmin, lnmax + 1);
            },
            getRoomLodgerParamName: function (prefix, index1, index2) {
                if ("undefined" === typeof (index2)) {
                    return prefix + ('000' + (index1 + 1)).slice(-3);
                } else {
                    return prefix + ('000' + (index1 + 1)).slice(-3) + ('000' + (index2 + 1)).slice(-2);
                }
            },
            getDaysClass: function (dayOfWeek, dayRow) {
                if (dayRow && dayRow.holiday) {
                    return 'holiday';
                } else if (dayOfWeek.sunday) {
                    return 'sunday';
                } else if (dayOfWeek.saturday) {
                    return 'saturday';
                }
                return null;
            },
            getCheckInDateClass: function (dateString) {
                if (!this.cinon && dateString == this.ci) {
                    return 'checkInDate';
                }
            },
            isDayUse: function () {
                if (this.dayuse === "Y") {
                    return true;
                }
                if (this.dayuse === "N") {
                    return false;
                }
            },
            getLtImploded: function (idxRoom) {
                if (this._ltImplode) {
                    return this._ltImplode[idxRoom];
                }
                return "";
            },
            getLnumImploded: function (idxRoom) {
                if (this._lnumImplode) {
                    return this._lnumImplode[idxRoom];
                }
                return "";
            },
            planIsActive: function (planCode) {
                return planCode === this.pl;
            },
            isPlanEnable: function(){
                // let items = $('.vacancy_sideList').find('.active');
                // console.log(items.length > 0);

                let _this = this;
                // const result = this.planListArea.filter(item => { (item.planCode === _this.selectPlanCode) || (item.planCode === _this.pl) });
                const result = this.planListArea.filter(item => item.planCode === _this.selectPlanCode );
                return result.length > 0;
            },
            getIconStyle: function (url) {
                return 'background-image: url("' + url + '")';
            },
            activatePlan: async function (planCode) {
                //プラン詳細を取得
                acivatePlanPlanDeffered = ajaxWrapper({
                    url: 'GSEA004A09',
                    type: 'GET',
                    data: {
                        hotelCode: this.hotelCode,
                        selectPlanCode: planCode,
                        ctrid: this.ctrid
                    },
                    headers: {
                        'Accept': 'application/json',
                    },
                });

                //選択されたプランのカレンダー情報を再表示
                let send_data = Array.from($(this.$refs.GSEA004F01600form).serializeArray());
                send_data = send_data.filter(item => ('undefined' !== typeof(item)));
                send_data.push({
                    name: 'selectPlanCode',
                    value: planCode,
                });
                acivatePlanCalendarDeffered = ajaxWrapper({
                    url: 'GSEA004A07',
                    type: 'GET',
                    data: send_data,
                    headers: {
                        'Accept': 'application/json',
                    },
                });

                // 2つのAjax終了を待ち合わせる
                try {
                    const data = await Promise.all([acivatePlanPlanDeffered, acivatePlanCalendarDeffered]);
                    // todo:プラン紹介文(detailViewTxt)以外もここで初期化する。そうしないと前回選択のプラン情報が表示されてしまう懸念あり
                    Vue.set(this, "detailViewTxt", "");

                    this._assignResponseData(data[0]);
                    data[1].searchResultMessage = data[1].displayMessage;
                    data[1].displayMessage = [];
                    this._assignResponseData(data[1]);
                    this._assignCalendarMessage(data[1]);
                    this._assignDPEnable(data[1]);
                    this.checkLodgingPossibleDate(this.calendarDispYear,this.lodgingPossibleDateTo);
                } catch (error) {
                    // console.log(error.status, error.getAllResponseHeaders())
                    const message = $t('common.label.search.error') + ' ' + $t('common.label.search.error.nextAction');
                    this.searchResultMessage = [message];
                } finally {
                    common.teardownSlick();
                }

                //ブラウザ履歴を書き換える
                const paramStr = this.buildSearchParameters() + this.buildDPCheckEnableParameter();
                const browserUrl = '/GSEA004F01600/GSEA004A01?' + paramStr;
                window.history.replaceState({ url: browserUrl }, null, browserUrl);
            },
            isDataExists: function (dayRow) {
                if (dayRow === null ||
                    dayRow.date === null) {
                    return false;
                }
                return true;
            },
            isOnSale: function (dayRow) {
                if (dayRow === null ||
                    dayRow.calendarItem === null ||
                    dayRow.calendarItem.planPrice === null ||
                    dayRow.calendarItem.planSalesStatusKbn === null ||
                    dayRow.calendarItem.planSalesStatusKbn === "" ) {
                    return false;
                }
                if (dayRow.calendarItem.planSalesStatusKbn === "－") {
                    return false;
                }
                return true;
            },
            isVacancyExist: function (dayRow) {
                if (dayRow === null ||
                    dayRow.calendarItem === null ||
                    dayRow.calendarItem.planPrice === null ||
                    dayRow.calendarItem.planSalesStatusKbn === null) {
                    return false;
                }
                if (dayRow.calendarItem.planSalesStatusKbn === "×" ||
                    dayRow.calendarItem.planSalesStatusKbn === "－") {
                    return false;
                }
                return true;
            },
            isVacancyFull: function (dayRow) {
                if (dayRow === null ||
                    dayRow.calendarItem === null ||
                    dayRow.calendarItem.planPrice === null ||
                    dayRow.calendarItem.planSalesStatusKbn === null) {
                    return false;
                }
                if (dayRow.calendarItem.planSalesStatusKbn === "○") {
                    return true;
                }
                return false;
            },
            getVacancyMark: function (dayRow) {
                if (dayRow === null || dayRow.calendarItem === null) {
                    return '';
                } else {
                    return dayRow.calendarItem.planSalesStatusKbn;
                }
            },
            isCalendarYearExist(yyyymm) {
                if (null === this.calendarSalesYearList) {
                    return false;
                }
                for (let csyf of this.calendarSalesYearList) {
                    if (csyf.calendarSalesYear === yyyymm) {
                        return true;
                    }
                }
                return false;
            },
            calendarYearChange: function (yyyymm) {
                const calendar = createCalendar(moment(yyyymm + "01").toDate());
                this.calendarDispYear = yyyymm;
                const merged = mergeCalendar(calendar, this.calendarDispYear, this.calendarSalesYearList);
                this.weeks = merged;
            },
            // 表示中の月が宿泊可能期間の終了月より未来（宿泊可能期間外）の場合、宿泊可能期間外メッセージをセット
            checkLodgingPossibleDate: function(calendarDispYear,lodgingPossibleDateTo) {
                const lodgingPossibleYearMonthTo = moment(this.lodgingPossibleDateTo,'YYYYMMDD').format('YYYYMM');
                if (lodgingPossibleYearMonthTo < this.calendarDispYear) {
                    this.screenTransitionIsEnabled = false;
                    this._assignOutOfLodgingPossibleDateMessage({
                        outOfLodgingPossibleDateMessage : this.mseadjs025,
                    });
                } else {
                    this.screenTransitionIsEnabled = true;
                    this._assignOutOfLodgingPossibleDateMessage({
                        outOfLodgingPossibleDateMessage : "",
                    });
                };
            },
            _assignResponseData: function (values) {
                for (let key in values) {
                    if (values[key]) {
                        Vue.set(this, key, values[key]);
                    }
                }
                this.calendarYearChange(this.calendarDispYear);
            },
            _assignCalendarMessage: function (data) {
                // NULL値が渡されることがあるため、明示的にセット
                this.calendarMessage = data.calendarMessage;
            },
            _assignOutOfLodgingPossibleDateMessage: function (data) {
                // NULL値が渡されることがあるため、明示的にセット
                this.outOfLodgingPossibleDateMessage = data.outOfLodgingPossibleDateMessage;
            },
            _assignDPEnable: function (data) {
                // 正常に更新されない場合があるため、明示的にセット
                this.dynamicPackagePlanAvailableCondition = data.dynamicPackagePlanAvailableCondition;
                this.dynamicPackageSearchCriteriaIgnoreDateAvailableCondition = data.dynamicPackageSearchCriteriaIgnoreDateAvailableCondition;
                console.log(data.dynamicPackagePlanAvailableCondition +" = "+ this.dynamicPackagePlanAvailableCondition)
            },
            goSearch: function () {
                $(".vacancy_main").addClass("calendar_loading");
                $(".calendar_noMatchTxt").css('display', 'none');

                $(".buttonType01.vacancyInput_submitBtn").addClass("disabledBtn");
                //カレンダーを取得
                ajaxWrapper({
                    url: 'GSEA004A03',
                    type: 'GET',
                    data: $(this.$refs.GSEA004F01600form).serializeArray(),
                    headers: {
                        'Accept': 'application/json',
                    },
                }).done((data, textStatus, jqXHR) => {
                    $(".buttonType01.vacancyInput_submitBtn").removeClass("disabledBtn");
                    $(".vacancy_main").removeClass("calendar_loading");
                    $(".calendar_noMatchTxt").css('display', 'block');
                    data.searchResultMessage = data.displayMessage;
                    data.displayMessage = [];
                    this._assignResponseData(data);
                    this._assignCalendarMessage(data);
                    this.checkLodgingPossibleDate(this.calendarDispYear, this.lodgingPossibleDateTo);
                    this._assignDPEnable(data)

                    const paramStr = this.buildSearchParameters() + this.buildDPCheckEnableParameter();
                    const browserUrl = '/GSEA004F01600/GSEA004A01?' + paramStr;
                    //ブラウザ履歴を書き換える
                    window.history.replaceState({ url: browserUrl }, null, browserUrl);
                }).fail((jqXHR, textStatus, errorThrown) => {
                    // console.log('通信失敗');
                    const message = $t('common.label.search.error') + ' ' + $t('common.label.search.error.nextAction');
                    this.searchResultMessage = [message];

                    $(".buttonType01.vacancyInput_submitBtn").removeClass("disabledBtn");
                    $(".vacancy_main").removeClass("calendar_loading");
                    $(".calendar_noMatchTxt").css('display', 'block');
                });
            },
            closeModalAndGoSearch: function () {
                this.rmInfoOk();
                // todo: goSearch内のajaxのdataのところを、formではなくvue内の変数から組み立てればsetTimeoutが不要
                setTimeout(() => {
                    this.goSearch();
                }, 5);
                // todo: 5でいいか不明
            },
            buildSearchParameters: function () {
                const searchParameter = new URLSearchParams();
                searchParameter.append('hotelCode', this.hotelCode);
                if (this.pl != null) {
                    searchParameter.append('pl', this.pl);
                }
                searchParameter.append('ci', this.ci);
                if (this.co != null) {
                    searchParameter.append('co', this.co);
                }
                if (this.stay != null) {
                    searchParameter.append('stay', this.stay);
                }

                if (this.rmInfo.length >= 2) { //「部屋ごとの人数を選択する」にチェックあり
                    for (let i = 1; i <= this.sumrm; i++) {
                        let name = 'rmcd' + ('000' + i).slice(-3);
                        let value = this.rmInfo[i - 1].rmcd;
                        searchParameter.append(name, value);
                    }
                    for (let i = 1; i <= this.sumrm; i++) {
                        let name = 'lt' + ('000' + i).slice(-3);
                        let value = this['lt'+('000' + i).slice(-3)];
                        searchParameter.append(name, value);
                    }
                    for (let i = 1; i <= this.sumrm; i++) {
                        let name = 'lnum' + ('000' + i).slice(-3);
                        let value = this['lnum'+('000' + i).slice(-3)];
                        searchParameter.append(name, value);
                    }
                } else { //「部屋ごとの人数を選択する」にチェックなし
                    for (let i = 1; i <= this.sumrm; i++) {
                        let name = 'rmcd' + ('000' + i).slice(-3);
                        let value = this.rmInfo[0].rmcd;
                        searchParameter.append(name, value);
                    }
                    for (let i = 1; i <= this.sumrm; i++) {
                        if (this.lt001 != null) {
                            let name = 'lt' + ('000' + i).slice(-3);
                            let value = this.lt001;
                            searchParameter.append(name, value);
                        }
                    }
                    for (let i = 1; i <= this.sumrm; i++) {
                        if (this.lnum001 != null) {
                            let name = 'lnum' + ('000' + i).slice(-3);
                            let value = this.lnum001;
                            searchParameter.append(name, value);
                        }
                    }
                }

                for (let i = 1; i <= this.sumrm; i++) {
                    let name = 'rm' + ('000' + i).slice(-3);
                    let value = i;
                    searchParameter.append(name, value);
                }
                searchParameter.append('sumrm', this.sumrm);
                searchParameter.append('cinon', this.cinon);
                searchParameter.append('dpck', this.isLnumPerRoom);
                if (this.ctrid != null) {
                    searchParameter.append('ctrid', this.ctrid);
                }
                searchParameter.append('dayuse', (this.dayuse === 'Y' ? 'true' : 'false'));
                if (this.ghaLanding) {
                    searchParameter.append('ghaLanding', this.ghaLanding);
                }

                const paramStr = searchParameter.toString();
                return paramStr;
            },
            buildDPCheckEnableParameter: function () {
                return '&DPCheckEnable=' + data_ve.DPCheckEnable;
            },
            isSearchResultMessageExists: function () {
                if (this.searchResultMessage === null ||
                    this.searchResultMessage.length === 0) {
                    return false;
                }
                return true;
            },
            goRoomChange: function () {
                this.doSubmitOtherAction('GSEA004A04');
            },
            goYoyaku: function (yyyymmdd, isDPLink) {
                this.$refs.s_calendarDate.value = yyyymmdd;
                this.$refs.s_calendarDate.value = yyyymmdd;
                this.ci = yyyymmdd;
                this.co = parseInt(this.stay) + parseInt(this.ci);
                if (isDPLink) {
                    this.goDPReservePage();
                    return;
                }
                this.doSubmitOtherAction('GSEA004A08');
            },
            goDPReservePage: function () {
                window.location.href =
                    window.location.protocol + '//' +
                    window.location.host + '/' +
                    ((window.$contextPath !== '/') ? window.$contextPath : '') +
                    data_ve.dynamicPackageReservationPagePath +
                    '?' + this.buildSearchParameters();
            },
            doSubmitOtherAction: function (action) {
                let _this = this;
                _this.$refs.GSEA004F01600form.action = action;
                _this.dontSubmitParam = true;
                Vue.nextTick(function () {
                    _this.$refs.GSEA004F01600form.submit();
                });
            },
            rmInfoCopy: function (srcIndex, dstIndex) {
                this.rmInfo[dstIndex] = JSON.parse(JSON.stringify(this.rmInfo[srcIndex]));
            },
            GSEA004A02init: function () {
                this.sumrmTemp = this.sumrm;
                if (this.sumrmComputed <= 0) {
                    let _this = this;
                    Vue.nextTick(function () {
                        _this.sumrmComputed = 1;
                    });
                }
            },
            rmInfoCancel: function () {
                Vue.nextTick(() => {
                    this.sumrmTemp = data_initial.sumrm;
                    this.isLnumPerRoom = data_initial.isLnumPerRoom;
                    this.rmInfo = JSON.parse(JSON.stringify(data_initial.rmInfo));
                });
            },
            // recalculate room member numbers
            ltInfoGet: function () {
                let ltInfo = Array.from([]);
                if (this.sumrmTemp == null) this.sumrmTemp = this.sumrm;
                if (this.isLnumPerRoom) {
                    for (let roomIndex in this.rmInfo) {
                        //console.log("rm=" + rm);
                        for (let ltIndex in this.rmInfo[roomIndex].ltInfo) {
                            if (!ltInfo[ltIndex]) {
                                ltInfo[ltIndex] = Object.assign({}, this.rmInfo[roomIndex].ltInfo[ltIndex]);
                                ltInfo[ltIndex].lnum = 0;
                            }
                            if (this.rmInfo[roomIndex].ltInfo[ltIndex].lnum) {
                                ltInfo[ltIndex].lnum += parseInt(this.rmInfo[roomIndex].ltInfo[ltIndex].lnum);
                            }
                        }
                    }
                } else {
                    for (let ltIndex in this.rmInfo[0].ltInfo) {
                        if (!ltInfo[ltIndex]) {
                            ltInfo[ltIndex] = Object.assign({}, this.rmInfo[0].ltInfo[ltIndex]);
                            ltInfo[ltIndex].lnum = parseInt(this.rmInfo[0].ltInfo[ltIndex].lnum) * this.sumrmTemp;
                        }
                    }
                }
                this.sumrm = this.sumrmTemp;
                return ltInfo;
            },
            rmInfoOk: function () {
                Vue.nextTick(() => {
                    if (!this.isLnumPerRoom) {
                        this.rmInfo.splice(1);
                    } else if (this.rmInfo.length > this.sumrmTemp) {
                        this.rmInfo.splice(this.sumrmTemp)
                    }
                    data_initial.sumrm = this.sumrmTemp;
                    data_initial.isLnumPerRoom = this.isLnumPerRoom;
                    data_initial.rmInfo = JSON.parse(JSON.stringify(this.rmInfo))
                    this.ltInfoJoinSave = null;
                    this.roomNameJoinSave = null;
                });
            },
            splitText: function (value) {
                return value ? value.split("\n") : '';
            },
            range: function (begin, end) {
                return range(begin, end);
            },
            initializeJQueryEvents: function () {
                let _this = this;
                window.setTimeout(function () {
                    common.setUpSlick(_this.$el);
                    common.modalEvents(_this.$el);
                }, 10);
            },
            disableScreenTransitionWithMessage: function() {
                //検索ボタン押下を促すメッセージ表示付きの画面遷移無効化
                this.screenTransitionIsEnabled = false;
                this._assignCalendarMessage({
                    calendarMessage : this.mseadja024,
                });
            },
            redirectToCompanyLogin: function () {
                common.redirectToCompanyLogin("");
            },
            convertHyperLink: common.convertHyperLink,
        },
        watch: {
            DPCheckEnable(newValue) {
                const cullentURL = new URL(window.location.href);
                cullentURL.searchParams.set('DPCheckEnable', newValue);
                window.history.replaceState({}, '', cullentURL.toString());
            },
        },
        updated: function () {
            this.$nextTick(this.initializeJQueryEvents);
        },
        beforeUpdate: function () {
            // common.teardownSlick();
        },
        filters: {
            localeNum: function (val) {
                return (new Number(val)).toLocaleString();
            },
        },
        components: {
            couponBanner,
            couponBannerModal,
            couponBadge,
            couponBadgeModal,
            couponBadgeBanner
        },
        mounted: function () {
            this.$nextTick(async () => {
                this.initializeJQueryEvents();

                holidaysData = await calendarCommon.getHolidaysData();
                this.calendarYearChange(this.calendarDispYear);
            });
        },
    });
}
